import React from 'react'

const RequestPayment = () => {
  return (
    <div>RequestPayment</div>
  )
}

export default RequestPayment